module.exports = __webpack_public_path__ + "img/detail-popup-hen.87ad4486.png";